/**
 * The side panel's approval card (Inspector → Pending approval).
 *
 * FRONT-3004: the same card as the chat and the phone (`ApprovalCardBody`),
 * same words and the same button order — it used to title every request with
 * its internal type ("tool-call"), show the raw request at all times and put
 * Deny before Approve, the reverse of the chat card beside it.
 */
import type { Approval } from '~/hooks/queries/use-approvals';
import { cardOf } from './approval-card-view';
import { ApprovalCardBody, ApprovalCardButtons, ApprovalCardFooter, approvalFrameClass } from './approval-card-body';

interface ApprovalCardProps {
  approval: Approval;
  onApprove: () => void;
  onReject: () => void;
}

export function ApprovalCard({ approval, onApprove, onReject }: ApprovalCardProps) {
  const card = cardOf(approval);
  return (
    <div data-testid="approval-card" data-kind={card.kind} className={approvalFrameClass(card.kind)}>
      <ApprovalCardBody approval={approval} card={card} />
      <ApprovalCardButtons card={card} onConfirm={onApprove} onCancel={onReject} />
      <ApprovalCardFooter card={card} />
    </div>
  );
}
